import { unstable_composeClasses as composeClasses } from '@mui/utils';
import { getDataGridUtilityClass } from "../constants/gridClasses.js";
export function composeGridClasses(classes, slots) {
  return composeClasses(slots, getDataGridUtilityClass, classes);
}